import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { addInvoicesToFlow } from '../../../lib/api/flow-api';
import { UploadFilesStep } from '../upload/UploadFilesStep';
import { Batch } from '../../../types';
import { Flow } from '../../../types/flow';
import { Icon } from '@ant-design/compatible';
import { ModalTitle } from '../../../components/text/Titles';

const spinIcon = <Icon type="loading" style={{ fontSize: 16 }} spin />;

type Props = {
  visible: boolean;
  onClose: () => any;
  onFinish: () => any;
  flow: Flow;
};

export const AddInvoices = (props: Props) => {
  const { visible, onClose, onFinish, flow } = props;

  const [batchUploadReports, setBatchUploadReports] = useState<Batch[]>([]);
  const [isCreating, setCreating] = useState<boolean>(false);

  const onCreate = async () => {
    setCreating(true);

    await addInvoicesToFlow(flow.id, batchUploadReports);
    onFinish();
    setCreating(false);
  };

  const nextButtonIsDisabled = () => {
    return isCreating || !batchUploadReports || batchUploadReports.length === 0;
  };

  const analyzeButton = (
    <Button key="submit" type="primary" size="large" onClick={onCreate} disabled={nextButtonIsDisabled()}>
      {isCreating && spinIcon} Analyze
    </Button>
  );

  return (
    <Modal
      maskClosable={false}
      width={768}
      visible={visible}
      title={<ModalTitle>Add Invoices</ModalTitle>}
      onOk={onCreate}
      onCancel={onClose}
      footer={[analyzeButton]}>
      <UploadFilesStep
        batchUploadReports={batchUploadReports}
        setBatchUploadReports={setBatchUploadReports}
        getPresignedParams={
          flow.model.algorithm.multiflow
            ? { customer: flow.multiflowCustomer, flowName: flow.multiflowName }
            : undefined
        }
        getPresignedUrl={flow.model.algorithm.multiflow ? '/api/generate-presigned-urls' : undefined}
      />
    </Modal>
  );
};
